module.exports = __webpack_public_path__ + "static/turkeyfor-svg-2cacb1a82afc5c3c8151934eabe2c27c.svg";